import type { MenuItem } from '~~/shared/services/menu/MenuItem';

export function getMenuTree(childrenOf?: MenuItem['path']): MenuItem[] {
  const menuTree: MenuItem[] = [
    {
      name: 'Products',
      path: '/',
      parentPrefix: [ '/products', '/wiresock' ],
      expandable: true,
      disableNavigation: true,
      children: [
        {
          name: 'WireSock Secure Connect',
          path: '/wiresock-secure-connect',
          children: [
            {
              name: 'WireSock Secure Connect',
              path: '/wiresock-secure-connect',
              hiddenInTree: true,
            },
            {
              name: 'Download',
              path: '/wiresock-secure-connect/download',
            },
            {
              icon: 'mdi-professional-hexagon',
              iconClass: 'ws-menu-icon--pro',
              name: 'PRO',
              path: '/wiresock-secure-connect/pro',
            },
            {
              name: 'Licensing',
              path: '/wiresock-secure-connect/licensing',
            },
            {
              name: 'Guides',
              path: '/wiresock-secure-connect/guides',
              expandable: true,
              disableNavigation: true,
              children: [
                {
                  name: 'How to start',
                  path: 'https://wiresock.net/documentation/wiresock-secure-connect/get-started.html',
                },
                {
                  name: 'Command Line Interface',
                  path: 'https://wiresock.net/documentation/wiresock-secure-connect/command-line-interface.html',
                },
                {
                  name: 'Advanced Configuration Parameters',
                  path: 'https://wiresock.net/documentation/wiresock-secure-connect/advanced-parameters.html',
                },
                {
                  name: 'Troubleshooting',
                  path: 'https://wiresock.net/documentation/wiresock-secure-connect/troubleshooting.html',
                },
              ],
            },
            {
              name: 'Release history',
              // path: '/wiresock-secure-connect/releases-history',
              path: 'https://wiresock.net/documentation/wiresock-secure-connect/release-history.html',
            },
          ],
        },
        {
          name: 'WireSock VPN Gateway',
          path: '/wiresock-vpn-gateway',
          children: [
            {
              name: 'WireSock VPN Gateway',
              path: '/wiresock-vpn-gateway',
              hiddenInTree: true,
            },
            {
              name: 'Download',
              path: '/wiresock-vpn-gateway/download',
            },
            {
              name: 'Package overview',
              // path: '/wiresock-vpn-gateway/package-overview',
              path: 'https://wiresock.net/documentation/wiresock-vpn-gateway/package-overview.html',
            },
            {
              name: 'Guides',
              path: '/wiresock-vpn-gateway/guides',
              expandable: true,
              disableNavigation: true,
              children: [
                {
                  name: 'Command Line Interface',
                  // path: '/wiresock-vpn-gateway/guides/command-reference',
                  path: 'https://wiresock.net/documentation/wiresock-vpn-gateway/command-line-interface.html',
                },
                {
                  name: 'Quick start: Windows Desktop',
                  // path: '/wiresock-vpn-gateway/guides/desktop',
                  path: 'https://wiresock.net/documentation/wiresock-vpn-gateway/quick-start-desktop.html',
                },
                {
                  name: 'Quick start: Windows Server Core',
                  // path: '/wiresock-vpn-gateway/guides/windows-server-core',
                  path: 'https://wiresock.net/documentation/wiresock-vpn-gateway/quick-start-windows-server-core.html',
                },
              ],
            },

          ],
        },
        // {
        //   name: 'Source code as product',
        //   path: '/wiresock-source-code-products',
        // },
        {
          name: 'WireSock Core SDK',
          path: '/wiresock-sdk',
        },
        {
          name: 'AmneziaWG Server Tools',
          path: '/wiresock-awg-server-tools',
          badge: 'New',
        },
        {
          name: 'WireSock ProxRoute',
          path: '/wiresock-proxroute',
          badge: 'Soon',
        },
      ],
    },
    {
      name: 'Documentation',
      path: 'https://wiresock.net/documentation',
    },
    {
      name: 'Custom Solutions',
      path: '/custom-solutions',
    },
    {
      name: 'About',
      path: '/about',
      expandable: true,
      disableNavigation: true,
      children: [
        {
          name: 'Contacts',
          path: '/about/contacts',
        },
        {
          name: 'Terms of Service',
          path: '/about/terms-of-service',
        },
        {
          name: 'Privacy Policy',
          path: '/about/privacy-policy',
        },
        {
          name: 'Refund Policy',
          path: '/about/refund-policy',
        },
      ],
    },
    //   {
    //     name: 'Tools: Check IP',
    //     path: '/tools/check-ip',
    //     hidden: true,
    //   },
  ];

  if (childrenOf) {
    return getChildrensOf(menuTree, childrenOf) || [];
  }

  return menuTree;
}

const getChildrensOf = (tree: MenuItem[], path: string): MenuItem[] | undefined => {
  for (const item of tree) {
    if (item.path === path) {
      return item.children;
    }
    if (item.children && path.startsWith(item.path)) {
      const items = getChildrensOf(item.children, path);
      if (items) {
        return items;
      }
    }
  }
  return undefined;
};

export function bindLinks(menuItem: MenuItem) {
  if (menuItem.path.startsWith('http')) {
    return {
      href: menuItem.path,
      target: '_self',
    };
  }
  return {
    to: menuItem.path,
  };
}

export function scrollContentTop() {
  window.scrollTo({
    top: 0,
  });
}
